import React from "react"

import {
	GridColDef,
} from "@mui/x-data-grid"

import {
    Brand,
    BrandManagementRequest,
    OrderType,
    PaginatedResponse,
    SearchFilter,
} from "models"
import {
    SbPaginatedDatagrid,
} from "components/commons"

import getBrandTableColumns from "./brandTableColumns"

interface BrandTableProps
{
    handleCallback: (data: BrandManagementRequest) => void
    data: PaginatedResponse<Brand> | null
}
interface BrandTableState
{
    pagination: SearchFilter
}
export class BrandTable extends React.Component<BrandTableProps, BrandTableState>
{
    private readonly columns: GridColDef[]

    constructor(props: BrandTableProps)
    {
        super(props)
        this.columns = getBrandTableColumns()
        this.state = {
            pagination: {
                pageSize: 10,
                pageId: 0,
                orderBy: "name",
                orderType: OrderType.ASCENDING,
            },
        }
    }

    componentDidMount()
    {
        this.props.handleCallback(this.state.pagination as BrandManagementRequest)
    }

    private onPaginationChanged = (pageId: number, pageSize: number): void => {
        this.setState(
            () => ({
                pagination: {
                    ...this.state.pagination,
                    pageSize: pageSize,
                    pageId: pageId,
                },
            }),
            () => this.props.handleCallback(this.state.pagination)
        )
    }

    private onSortChanged = (orderBy: string|null, orderType: OrderType|null): void => {
        this.setState(
            () => ({
                pagination: {
                    pageSize: this.state.pagination.pageSize,
                    pageId: this.state.pagination.pageId,
                    orderBy: orderBy,
                    orderType: orderType,
                },
            }),
            () => this.props.handleCallback(this.state.pagination)
        )
    }

    render()
    {
        return (
            <SbPaginatedDatagrid
                columns={this.columns}
                data={this.props.data}
                pagination={this.state.pagination}
                onPaginationChanged={this.onPaginationChanged}
                onSortChanged={this.onSortChanged}
            />
        )
    }
}
